import { TableCell, TableRow, Typography } from "@material-ui/core";
import { FC } from "react";
import { TrackerData } from "types/Tracker";
import { useStyles } from "./styles";
import { TrackerRowCell } from "./TrackerRowCell";

interface TrackerRowProps {
  tableRow: TrackerData;
}

export const TrackerRow: FC<TrackerRowProps> = ({ tableRow }) => {
  const classes = useStyles();

  return (
    <TableRow key={`${tableRow.transporter_id}`} hover>
      <TableCell className={classes.tableCell}>
        <Typography variant="body2">{tableRow.name}</Typography>
      </TableCell>
      <TableCell className={`${classes.tableCell} ${classes.leftBorderCell}`}>
        <Typography variant="body2">{tableRow.tenured ? tableRow.tenured : 0}</Typography>
      </TableCell>
      <TableCell className={`${classes.tableCell} ${classes.leftBorderCell}`}>
        <Typography variant="body2">{tableRow.badge}</Typography>
      </TableCell>
      <TableCell className={`${classes.tableCell} ${classes.leftBorderCell}`}>
        <Typography variant="body2">{tableRow.transporter_id}</Typography>
      </TableCell>
      {TrackerRowCell(tableRow.availability_count, "availability")}
      {TrackerRowCell(tableRow.actual_shifts, "shifts")}
      {TrackerRowCell(tableRow.confirmed, "confirmed", tableRow.actual_shifts)}
      {TrackerRowCell(tableRow.rejected, "rejected")}
      {TrackerRowCell(tableRow.client_cancelled, "client_cancelled")}
      {TrackerRowCell(tableRow.mycu_cancelled, "mycu_cancelled")}
    </TableRow>
  );
};
